import { h } from 'preact'
import Moment from 'moment'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Project = props => {
    let project = props.project
    let title = project.title.rendered
    let location = project.custom_meta[0].location
    let link = project.link
    let excerpt = project.excerpt.rendered
    let raw_date = project.date
    let date = Moment(raw_date).format('DD/MM/YYYY')
    let feat_image = project.feat_image

    let text_show = 'Bekijk project'

    if (props.language == 'en') {
        text_show = 'View project'
        date = Moment(raw_date).format('MM/DD/YYYY')
    }

    return (
        <div className="c-project c-projects__col">
            <div className="c-project__image u-image">
                <div dangerouslySetInnerHTML={{ __html: feat_image }}/>
            </div>

            <div className="c-project__header u-flex u-flex-sb">
                <div className="c-project__markets"
                     dangerouslySetInnerHTML={{ __html: location }}/>
            </div>

            <div className="c-project__body">
                <h3 className="c-project__title"
                    dangerouslySetInnerHTML={{ __html: title }}/>
                <div className="c-project__excerpt"
                     dangerouslySetInnerHTML={{ __html: excerpt }}/>
            </div>
            <div className="c-project__footer">
                <a href={link}
                   className="c-button c-button--yellow c-project__button">Lees
                                                                           verder</a>
            </div>
        </div>
    )
}

export default Project

// WEBPACK FOOTER //
// ./src/js/projects/components/Project.js
